import { InvoiceStatus } from 'types/invoice-status';

export const ALL_INVOICE_STATUSES = Object.values(InvoiceStatus);
